import { render, staticRenderFns } from "./StockCategoriesTab.vue?vue&type=template&id=7414db8c&"
import script from "./StockCategoriesTab.vue?vue&type=script&lang=js&"
export * from "./StockCategoriesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports